import * as React from 'react';
import { cn } from '../../lib/cn.js';

/** Keyboard shortcut hint, e.g. <Kbd>Ctrl</Kbd> + <Kbd>K</Kbd>. */
export const Kbd = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(function Kbd({ className, ...props }, ref) {
  return (
    <kbd
      ref={ref}
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-[4px] border border-border-subtle bg-surface-subtle px-1 font-sans text-meta font-medium text-text-secondary',
        className,
      )}
      {...props}
    />
  );
});
